export const notEqualUnknownFilter = (field: string) => {
  return [
    {
      field,
      key: null,
      op: 'not_eq',
      value: 'CONVIVA_INTERNAL_UNKNOWN',
      display: 'UNKNOWN',
      originalField: field,
    },
  ];
};
